module.exports = __webpack_public_path__ + "svgs/coupon-4.78f3cacb.svg";